export default "__VITE_ASSET__kAHNqH_N__"